import React, { Fragment } from 'react';
import moment from 'moment';

import { List, ListItem, MenuButton, Icons } from '@silverfort/sf-components';
import { MenuItemDivider } from '../DropdownMenu/MenuItem';

import AdminConsoleIcon from '../common/NewImages/admin-console.svg';
import activeSpsIcon from './Images/active_sps.png';
import nonactiveSpsIcon from './Images/non_active_sps.png';
import disabledSpsIcon from './Images/disabled_sps.png';

import { SYSTEM_MODES } from '@silverfort-nodelibs/common/utils/system-mode-config';
import { Checkbox } from '@material-ui/core';
import { TOWER_ID } from '@silverfort-nodelibs/common/utils/consts';
import { downloadFile, httpGet } from '../utils';
import { MmsCmsConnectivityStatus } from './SystemSettingsComponents/MmsCmsConnectivityStatus.js';
import { FeatureLock } from '../common/LockedFeatures';
import { DisabledDisplayOptions } from '../SystemSettings/hooks/lockedFeatures/types';

class AdminConsoleStatusRow extends React.Component {
    state = {
        isGeneratingLog: this.props.adminConsoleData.isGeneratingLog
    };

    componentDidMount() {
        const locale = navigator.languages ? navigator.languages : navigator.language;
        moment.locale(locale);
    }

    render() {
        const isOnPrem = this.props.systemMode === SYSTEM_MODES.ON_PREM;
        let towerAryaSync = null;
        if (this.props.adminConsoleData.isAryaEnabled && this.props.adminConsoleData.isAryaConnected) {
            towerAryaSync = <img src={activeSpsIcon} alt="" />;
        } else if (this.props.adminConsoleData.isAryaEnabled && !this.props.adminConsoleData.isAryaConnected) {
            towerAryaSync = <img src={nonactiveSpsIcon} alt="" />;
        } else if (!this.props.adminConsoleData.isAryaEnabled) {
            towerAryaSync = <img src={disabledSpsIcon} alt="" />;
        }

        let lastLog = 'N/A';
        if (this.props.adminConsoleData.lastLog) {
            const logTime = moment(this.props.adminConsoleData.lastLog).local();
            if (logTime.isValid()) {
                lastLog = logTime.format('L') + ', ' + logTime.format('LTS');
            }
        }

        return (
            <div className={'serverRow nodeServerRow' + (this.props.isHeader ? ' tableHeader' : '')}>
                <div className={'title'}>
                    <div className="leftSide">
                        {this.props.isHeader && (
                            <Fragment>
                                <Checkbox
                                    disableRipple={true}
                                    checked={this.props.isAdminConsoleSelected}
                                    onChange={() => this.props.checkAdminConsole()}
                                    onClick={(e) => e.stopPropagation()}
                                    color="primary"
                                    style={{
                                        transform: 'scale(0.667)'
                                    }}
                                    className="pl-0"
                                />
                                <div className="tableHeaderTitle notification name w-[180px]">Name</div>
                                <div className="tableHeaderTitle notification status">Status</div>
                            </Fragment>
                        )}
                        {!this.props.isHeader && (
                            <Fragment>
                                <Checkbox
                                    disableRipple={true}
                                    checked={this.props.isAdminConsoleSelected}
                                    onChange={() => this.props.checkAdminConsole()}
                                    onClick={(e) => e.stopPropagation()}
                                    color="primary"
                                    style={{
                                        transform: 'scale(0.667)'
                                    }}
                                    className="pl-0"
                                />
                                <img src={AdminConsoleIcon} alt="" />
                                <div className="wallHeader w-[203px]" title={'Silverfort Console'}>
                                    <div className="nodeNameContainer">
                                        <div className="nodeDisplayName">Silverfort Console</div>
                                    </div>

                                    {this.props.adminConsoleData && (
                                        <div className="ipAddress" title={this.props.adminConsoleData.version}>
                                            {this.props.adminConsoleData.version}
                                        </div>
                                    )}
                                </div>
                                <div className={`wallState active`}>Active</div>
                            </Fragment>
                        )}
                    </div>
                    <div className="rightSide">
                        {this.props.isHeader && (
                            <Fragment>
                                <div className={'ravenSync notification tableHeaderTitle w-64'}>Messaging Service</div>
                                <FeatureLock
                                    displayOptions={{
                                        enabled: this.props.isMfaOrPasEnabledByLicense,
                                        disabledDisplay: DisabledDisplayOptions.HIDDEN
                                    }}>
                                    {isOnPrem && (
                                        <div className={'ravenSync notification tableHeaderTitle w-64'}>
                                            Desktop Messaging Service Status
                                        </div>
                                    )}
                                </FeatureLock>
                                <div className={'lastGeneratedLog notification timestamp tableHeaderTitle'}>
                                    Last Generated Log
                                </div>
                                <div className={'actions notification tableHeaderTitle'}>Actions</div>
                            </Fragment>
                        )}
                        {!this.props.isHeader && (
                            <Fragment>
                                <div className="flex ravenSync notification w-64 justify-center">
                                    {this.props.hasServiceBus && (
                                        <MmsCmsConnectivityStatus
                                            name={'MMS'}
                                            offlineMode={this.props.adminConsoleData.offlineMode}
                                            isActive={this.props.adminConsoleData.isRavenConnected}
                                            showText={false}
                                            showTooltip={true}
                                            className="w-fit"
                                        />
                                    )}
                                    <MmsCmsConnectivityStatus
                                        name={'CMS'}
                                        offlineMode={this.props.adminConsoleData.offlineMode}
                                        isActive={this.props.adminConsoleData.isPhoenixConnected}
                                        showText={false}
                                        showTooltip={true}
                                        className="w-fit"
                                    />
                                </div>

                                <FeatureLock
                                    displayOptions={{
                                        enabled: this.props.isMfaOrPasEnabledByLicense,
                                        disabledDisplay: DisabledDisplayOptions.HIDDEN
                                    }}>
                                    {isOnPrem && <div className="ravenSync notification w-64"> {towerAryaSync}</div>}
                                </FeatureLock>
                                <div className="lastGeneratedLog timestamp">
                                    {this.props.adminConsoleData.isGeneratingLog && (
                                        <i className={'fa fa-refresh fa-spin'} aria-hidden="true"></i>
                                    )}
                                    <span>{lastLog}</span>
                                </div>
                                <div
                                    className="actions"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                    }}>
                                    <MenuButton
                                        className={`left-[-140px] text-left text-white`}
                                        buttonStyle="PrimarySolid"
                                        text={'Actions'}
                                        iconRight={Icons.ChevronDown}
                                        id={'action-dropdown' + TOWER_ID}
                                        content={
                                            <List>
                                                {isOnPrem && (
                                                    <>
                                                        <ListItem
                                                            title="Generate Admin Console log"
                                                            disabled={this.state.isGeneratingLog}
                                                            onClick={this.props.generateAdminConsoleLogs}
                                                        />
                                                        <ListItem
                                                            title="Download Admin Console log"
                                                            onClick={() =>
                                                                downloadFile(`/Settings/DownloadServerLogs/tower`)
                                                            }
                                                            disabled={
                                                                !this.props.adminConsoleData.lastLog ||
                                                                lastLog === 'N/A'
                                                            }
                                                        />
                                                    </>
                                                )}
                                                <ListItem
                                                    title="Generate Platform logs"
                                                    disabled={this.props.isGeneratingPlatformLogs}
                                                    onClick={() => httpGet(`/Settings/GeneratePlatformLogs`)}
                                                />
                                                {isOnPrem && (
                                                    <ListItem
                                                        title="Download Platform logs"
                                                        onClick={() => downloadFile(`/Settings/DownloadPlatformLogs`)}
                                                        disabled={!this.props.isPlatformLogExists}
                                                    />
                                                )}
                                            </List>
                                        }
                                    />
                                </div>
                            </Fragment>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default AdminConsoleStatusRow;
